import * as React from 'react'
import * as css from './TableOfContents.module.css'
import slugify from 'slugify'

export default function TableOfContents({ headings }) {
	React.useEffect(() => {
		if (typeof document === 'undefined') return

		const headerHeight =
			document.querySelector('body > header')?.clientHeight || 0

		headings?.forEach((heading) => {
			const target = document.getElementById(slug(heading))

			if (!target) return

			const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						const tocItem = document.querySelector(
							`[data-toc-item="${slug(heading)}"]`,
						)

						if (entry.isIntersecting) {
							tocItem?.classList.add(css.inView)
						} else {
							tocItem?.classList.remove(css.inView)
						}
					})
				},
				{
					threshold: 1,
					rootMargin: `-${headerHeight}px 0px 0px 0px`,
				},
			)

			observer.observe(target)

			return () => observer.disconnect()
		})
	}, [headings])

	return (
		<aside className="md:sticky-below-header min-w-0 md:max-w-[300px]">
			<nav>
				<ul className="<md:hidden">
					{headings.map((heading, key) => (
						<li data-toc-item={slug(heading)} key={key}>
							<a
								className="block border-l-[3px] p-3 text-ink/70 transition-colors hover:border-ft-green hover:text-ink"
								href={`#${slug(heading)}`}
							>
								{heading}
							</a>
						</li>
					))}
				</ul>

				<select
					className="fullwidth rounded-none border-l-4 border-ft-green bg-suede-white p-4 md:hidden"
					onChange={(e) => {
						window.location.href = `#${e.target.value}`
						e.currentTarget.value = slug(headings[0])
					}}
				>
					{headings.map((heading, key) => (
						<option value={slug(heading)} key={key}>
							{heading}
						</option>
					))}
				</select>
			</nav>
		</aside>
	)
}

function slug(string) {
	if (!string) return ''
	return slugify(string, { lower: true, remove: /’:/g })
}
